import(/* webpackMode: "eager" */ "/home/runner/work/dentalMap-front/dentalMap-front/src/app/page.tsx")